export default "__VITE_ASSET__a23dccba__"